/**
 * Tagalys Event Bus
 * Shared pub/sub system for autocomplete and results systems
 */

class TagalysEventBus {
	constructor () {
		this.events = {}
	}

	subscribe (eventName, callback) {
		if (!this.events[eventName]) {
			this.events[eventName] = []
		}
		this.events[eventName].push(callback)
	}

	unsubscribe (eventName, callback) {
		if (!this.events[eventName]) return
		this.events[eventName] = this.events[eventName].filter(cb => cb !== callback)
	}

	publish (eventName, data) {
		if (!this.events[eventName]) return
		this.events[eventName].forEach(callback => callback(data))
	}
}

// Initialize namespaces
window.theme = window.theme || {}
window.theme.tagalys = window.theme.tagalys || {}
window.theme.tagalys.searchAutocomplete = window.theme.tagalys.searchAutocomplete || {}
window.theme.tagalys.results = window.theme.tagalys.results || {}

// Create separate instances for each system
window.theme.tagalys.searchAutocomplete.eventBus = new TagalysEventBus()
window.theme.tagalys.results.eventBus = new TagalysEventBus()
